import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from 'components/Button';
import NewsBlock from 'components/NewsBlock';
import OnPageEditing from 'components/OnPageEditing';

import css from './NewsListBlock.module.scss';
import { THEMES, getThemeClassNames } from 'constants/themes';

const NewsListBlock = ({
    blockId,
    header,
    description,
    readMoreLink,
    readMoreText,
    articles,
    publishedLabel,
    theme,
    showReadMore,
    frontpage,
    horizontal,
}) => (
    <div
        className={cn(css['newslist-block'], getThemeClassNames(css, theme), {
            [css.frontpage]: frontpage,
            [css.horizontal]: horizontal,
        })}
        data-block={blockId}
    >
        <header>
            <OnPageEditing property="Header">
                <h2 className={css['block-heading']}>{header}</h2>
            </OnPageEditing>
            <OnPageEditing property="Description">
                {description && (
                    <p className={css.description}>
                        {description}
                    </p>
                )}
            </OnPageEditing>
        </header>
        <ul className={css.articles}>
            {articles.length > 0 && articles.map((news, i) => (
                <li key={i}>
                    <NewsBlock
                        key={i}
                        publishedLabel={publishedLabel}
                        frontpage={frontpage}
                        horizontal={horizontal}
                        {...news}
                    />
                </li>
            ))}
        </ul>
        <OnPageEditing property="ReadMoreLink">
            {showReadMore && readMoreText && readMoreLink && (
                <Button href={readMoreLink} secondary {...{light : theme === THEMES.darkgray}}>
                    {readMoreText}
                </Button>
            )}
        </OnPageEditing>
    </div>
);

NewsListBlock.propTypes = {
    frontpage: PropTypes.bool.isRequired,
    blockId: PropTypes.number.isRequired,
    header: PropTypes.string,
    description: PropTypes.string,
    readMoreLink: PropTypes.string,
    readMoreText: PropTypes.string,
    articles: PropTypes.array.isRequired,
    publishedLabel: PropTypes.string,
    theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
    showReadMore: PropTypes.bool.isRequired,
    horizontal: PropTypes.bool,
};

NewsListBlock.defaultProps = {
    showReadMore: true,
    theme: 0,
    horizontal: false,
    frontpage: false
};

export default NewsListBlock;



// WEBPACK FOOTER //
// ./src/components/NewsListBlock/NewsListBlock.jsx